import { apiClient } from '../lib/apiClient';

/** `POST /files/upload` 的 201 响应（`04-api-contract.md` §17.1） */
export interface UploadedFileView {
  url: string;
  filename: string;
  size: number;
  mimeType: string;
}

/**
 * 上传一个文件并拿到服务端路径。
 *
 * 表单字段名必须是 `file` 与 `subdir`（契约 §17.1）：`subdir` 走服务端白名单，
 * 写错只会得到 400 `FILE_INVALID_SUBDIR`，而错误信息不会告诉你正确拼写。
 * 货架图标用 `shelf_icons`（§17.1 白名单：png/jpeg/webp，5 MB）。
 */
export function uploadFile(file: File, subdir: string): Promise<UploadedFileView> {
  const form = new FormData();
  form.append('file', file);
  form.append('subdir', subdir);
  return apiClient.post<UploadedFileView>('/files/upload', form);
}
